import { render } from "./Berita.vue?vue&type=template&id=84f2b5a0"
import script from "./Berita.vue?vue&type=script&lang=js"
export * from "./Berita.vue?vue&type=script&lang=js"

import "./Berita.vue?vue&type=style&index=0&id=84f2b5a0&lang=css"

import exportComponent from "/opt/FE_Compro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__